import React from "react";

const Svg = ({ children, size = 24, stroke = 1.8, className }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={stroke}
    width={size}
    height={size}
    className={className}
    aria-hidden
  >
    {children}
  </svg>
);

export const IconHome = (p) => (
  <Svg {...p}><path d="M3 10.5 12 3l9 7.5V21h-6v-6h-6v6H3z" /></Svg>
);
export const IconChat = (p) => (
  <Svg {...p}><path d="M21 12a8.5 8.5 0 0 1-12.4 7.6L3 21l1.4-5.6A8.5 8.5 0 1 1 21 12z" /></Svg>
);
export const IconMega = (p) => (
  <Svg {...p}><path d="M3 11l16-6v14L3 13v-2zM7 14v5" /></Svg>
);
export const IconBag = (p) => (
  <Svg {...p}><path d="M4 7h16l-1.5 12h-13L4 7zM8 7a4 4 0 0 1 8 0" /></Svg>
);
export const IconChart = (p) => (
  <Svg {...p}><path d="M4 20V10M10 20V4M16 20v-8M22 20H2" /></Svg>
);
export const IconGear = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19 12a7 7 0 0 0-.1-1.2l2-1.6-2-3.4-2.4 1a7 7 0 0 0-2-1.2L14 3h-4l-.5 2.6a7 7 0 0 0-2 1.2l-2.4-1-2 3.4 2 1.6A7 7 0 0 0 5 12c0 .4 0 .8.1 1.2l-2 1.6 2 3.4 2.4-1a7 7 0 0 0 2 1.2L10 21h4l.5-2.6a7 7 0 0 0 2-1.2l2.4 1 2-3.4-2-1.6c.1-.4.1-.8.1-1.2z" />
  </Svg>
);
export const IconGrid = (p) => (
  <Svg {...p}>
    <rect x="3" y="3" width="7" height="9" rx="1.5" />
    <rect x="14" y="3" width="7" height="5" rx="1.5" />
    <rect x="14" y="12" width="7" height="9" rx="1.5" />
    <rect x="3" y="16" width="7" height="5" rx="1.5" />
  </Svg>
);
export const IconPhone = (p) => (
  <Svg {...p}>
    <rect x="7" y="2" width="10" height="20" rx="2.5" />
    <path d="M11 18h2" />
  </Svg>
);
export const IconQr = (p) => (
  <Svg {...p}>
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <path d="M14 14h3v3h-3zM20 14h1M14 20h1M20 20h1" />
  </Svg>
);
export const IconWallet = (p) => (
  <Svg {...p} stroke={2}>
    <rect x="2" y="6" width="20" height="14" rx="2.5" />
    <path d="M2 10h20" />
  </Svg>
);
export const IconDoc = (p) => (
  <Svg {...p}>
    <path d="M6 2h9l5 5v15H6z" />
    <path d="M15 2v5h5M9 13h6M9 17h6" />
  </Svg>
);
export const IconKey = (p) => (
  <Svg {...p}>
    <circle cx="8" cy="15" r="4.5" />
    <path d="M11.5 11.5 21 2M17 6l3 3" />
  </Svg>
);
export const IconBook = (p) => (
  <Svg {...p}>
    <path d="M4 4h7v16H6a2 2 0 0 1-2-2V4zM20 4h-7v16h5a2 2 0 0 0 2-2V4z" />
  </Svg>
);
export const IconShield = (p) => (
  <Svg {...p}><path d="M12 2 4 5v6c0 5 3.5 9 8 11 4.5-2 8-6 8-11V5l-8-3z" /></Svg>
);
export const IconDown = (p) => (
  <Svg {...p}><path d="M12 3v12M6 11l6 6 6-6M4 21h16" /></Svg>
);
export const IconPeople = (p) => (
  <Svg {...p}>
    <circle cx="9" cy="8" r="3.5" />
    <path d="M2.5 20a6.5 6.5 0 0 1 13 0M16 4.5a3.5 3.5 0 0 1 0 7M21.5 20a6.5 6.5 0 0 0-4.5-6.1" />
  </Svg>
);
export const IconTag = (p) => (
  <Svg {...p}>
    <path d="M3 3h8l10 10-8 8L3 11V3z" />
    <circle cx="8" cy="8" r="1.5" />
  </Svg>
);
export const IconList = (p) => (
  <Svg {...p}><path d="M8 6h13M8 12h13M8 18h13M3.5 6h.01M3.5 12h.01M3.5 18h.01" /></Svg>
);
export const IconBot = (p) => (
  <Svg {...p}>
    <rect x="4" y="8" width="16" height="12" rx="2.5" />
    <path d="M12 8V4M8 2h8" />
    <circle cx="9" cy="13.5" r="1.2" />
    <circle cx="15" cy="13.5" r="1.2" />
  </Svg>
);
export const IconForm = (p) => (
  <Svg {...p}>
    <rect x="4" y="3" width="16" height="18" rx="2.5" />
    <path d="M8 8h8M8 12h8M8 16h5" />
  </Svg>
);
export const IconOrder = (p) => (
  <Svg {...p}>
    <path d="M6 6h15l-2 8H8L5.5 3H2" />
    <circle cx="9" cy="20" r="1.6" />
    <circle cx="17" cy="20" r="1.6" />
  </Svg>
);
export const IconPay = (p) => (
  <Svg {...p}>
    <rect x="2" y="5" width="20" height="14" rx="2.5" />
    <path d="M2 9h20M6 15h4" />
  </Svg>
);
export const IconUser = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21a8 8 0 0 1 16 0" />
  </Svg>
);
export const IconSearch = (p) => (
  <Svg {...p} stroke={2}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
  </Svg>
);
export const IconBell = (p) => (
  <Svg {...p}>
    <path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 0 1-3.4 0" />
  </Svg>
);
export const IconHelp = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M9.5 9a2.5 2.5 0 1 1 3.4 2.3c-.8.3-.9 1-.9 1.7M12 17h.01" />
  </Svg>
);
export const IconSwap = (p) => (
  <Svg {...p} stroke={2}><path d="M7 15l5 5 5-5M7 9l5-5 5 5" /></Svg>
);
export const IconLogout = (p) => (
  <Svg {...p}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" /></Svg>
);
export const IconBack = (p) => (
  <Svg {...p}><path d="M15 6l-6 6 6 6" /></Svg>
);

export const ICONS = {
  grid: IconGrid,
  phone: IconPhone,
  qr: IconQr,
  wallet: IconWallet,
  doc: IconDoc,
  key: IconKey,
  book: IconBook,
  shield: IconShield,
  down: IconDown,
  chat: IconChat,
  people: IconPeople,
  tag: IconTag,
  chart: IconChart,
  mega: IconMega,
  list: IconList,
  bot: IconBot,
  form: IconForm,
  bag: IconBag,
  order: IconOrder,
  pay: IconPay,
  gear: IconGear,
  user: IconUser,
  logout: IconLogout,
};
